import { render, staticRenderFns } from "./FactsheetFooter.vue?vue&type=template&id=1809222c&scoped=true&"
import script from "./FactsheetFooter.vue?vue&type=script&lang=js&"
export * from "./FactsheetFooter.vue?vue&type=script&lang=js&"
import style0 from "./FactsheetFooter.vue?vue&type=style&index=0&id=1809222c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1809222c",
  null
  
)

export default component.exports